export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home'
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        requiresAuth: true,
        requiresPermission: 'view_dashboard'
      },
    },
    {
      name: 'benchmark_report',
      displayName: 'Benchmark',
      meta: {
        icon: 'entypo entypo-chart-bar',
        // requiresAuth: true,
        requiresPermission: 'view_benchmark_report'
      },
      disabled: true
    },
    {
      name: 'maps',
      displayName: 'Demographic Analysis',
      meta: {
        icon: 'vuestic-iconset-maps',
        // requiresAuth: true,
        requiresPermission: 'view_demographics'
      },
      disabled: true,
    },
  ]
}
